import { render, staticRenderFns } from "./DetalleOrtodonciaOrtopedia.vue?vue&type=template&id=6d50f38e&scoped=true"
import script from "./DetalleOrtodonciaOrtopedia.vue?vue&type=script&lang=js"
export * from "./DetalleOrtodonciaOrtopedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d50f38e",
  null
  
)

export default component.exports